// deno-lint-ignore-file ban-unused-ignore no-explicit-any no-empty-interface
///////////////////////////////////
// !!! DO NOT EDIT THIS FILE !!! //
///////////////////////////////////

import type { SlackAPIResponse } from "../response";
export type ConversationsAcceptSharedInviteResponse = SlackAPIResponse & {
  can_open_scdm?: boolean;
  channel_id?: string;
  error?: string;
  implicit_approval?: boolean;
  invite_id?: string;
  needed?: string;
  ok: boolean;
  provided?: string;
};
